// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"0f9b7134","909":"8b571079"}[chunkId] + ".chunk.css";
};